export const PhoneNumberRegEx = new RegExp('^$|(\\+[0-9]{1,3})?[0-9]{10}$');
export const PhoneNumberDashesRegEx = new RegExp('^[0-9. ]*$');
export const UsphoneNumberRegEx = new RegExp(
  '^(\\([0-9]{3}\\)|[0-9]{3}-)[0-9]{3}-[0-9]{4}$'
);
export const PostalCodeCARegex = new RegExp(
  '^[A-Za-z]\\d[A-Za-z][ ]?\\d[A-Za-z]\\d$'
);
export const PhoneUsRegEx = new RegExp('^([0-9]{3}) [0-9]{3}-[0-9]{4}$');
export const AlphaNumericRegex = new RegExp('^[a-zA-Z0-9]*$');
export const AlphaNumerictrackinglocationRegex = new RegExp('^[-\\w\\s]+$');
export const AlphaNumericspaceRegex = new RegExp('^[a-zA-Z ]*$');
export const NumbersonlyRegEx = new RegExp('^[0-9]');
export const FirstltrcapitalRegEx = new RegExp('^[A-Z][a-z]');
export const MustbNumericRegEx = new RegExp('^(0|[1-9][0-9]*)$');
export const PostalCodeRegEx = new RegExp('^[0-9]{5}(?:-[0-9]{4})?$');
export const emailRegEx = new RegExp(
  '^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'
);
export const emailcapsRegEx = new RegExp(
  '^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,3}$'
);
export const commentsRegEx = new RegExp('^[a-zA-Z0-9. ]*$');
export const onlySpaceRegEx = new RegExp('^\\w+(\\s\\w+)*$');
export const customercomplaintRegEx = new RegExp('[ ]{3,}');
export const NonkeycharacterRegEx = new RegExp(
  '^[a-zA-Z0-9.!@?#"$%&:\';()*+,/;-=[\\]^_{|}<>~` ]+$'
);
export const AplhanumerichypenRegEx = new RegExp('^[a-zA-Z0-9-]+$');
